import { Text, Stack, Box } from 'braid-design-system';

import PollDialog from 'src/components/atoms/PollDialog/PollDialog';
import type { PageName } from 'src/core/utils/pageUtil';
import { parseHttpLinks } from 'src/core/utils/urlUtil';
import type { Poll } from 'src/mapper/threadMapper';
import { usePage } from 'src/provider/page';

import * as styles from './ThreadContent.css';

interface ThreadTextProps {
  isMainThread?: boolean;
  text: string;
  images?: string[];
  maxLines?: number;
  poll?: Poll;
  onVote?: (optionId: string) => void;
  voted?: boolean;
}

const textWithLinks = (
  text: string,
  pageName: PageName,
  disableLinks?: boolean,
) => {
  const textParts = parseHttpLinks(text);

  return textParts.map((part, index) =>
    part.type === 'link' && pageName === 'CommunityThreadDetails' ? (
      <a
        key={index}
        href={part.value}
        target="_blank"
        rel="nofollow noopener noreferrer"
        className={
          disableLinks ? styles.NonClickableLink : styles.ClickableLink
        }
      >
        {part.value}
      </a>
    ) : (
      <span key={index}>{part.value}</span>
    ),
  );
};

export default ({
  isMainThread = false,
  text,
  images,
  maxLines,
  poll,
  onVote,
  voted = false,
}: ThreadTextProps) => {
  const {
    pageState: { pageName },
  } = usePage();
  return (
    <Stack space="medium">
      <Box className={styles.ThreadContentFormatting}>
        {Boolean(maxLines) ? (
          <Text
            id="Content"
            size="small"
            weight={isMainThread ? 'medium' : 'regular'}
            maxLines={maxLines}
          >
            {textWithLinks(text, pageName, true)}
          </Text>
        ) : (
          <Text
            id="Content"
            size="small"
            weight={isMainThread ? 'medium' : 'regular'}
          >
            {textWithLinks(text, pageName, false)}
          </Text>
        )}
      </Box>
      {images &&
        images.length > 0 &&
        images.map((image) => (
          <img className={styles.ThreadContentImage} key={image} src={image} />
        ))}
      {poll && <PollDialog poll={poll} onClick={onVote} voted={voted} />}
    </Stack>
  );
};
